import {createBasicReducer} from '../../utils/redux'
import {basicActions, checkClassPasscode} from './actions'
import {initialState} from './constants'
import {BookingState} from './types'

export const reducer = createBasicReducer<BookingState>(initialState, basicActions)

reducer.on(checkClassPasscode, (state) => state)
